module.exports = __webpack_public_path__ + "img/mvl-calc-chart.1e32e4f1.jpg";